<template>
  <div class="introduceMyself-warpper">
    <nav-bar titleText="填写信息" titleWeight="bold" @goBack="goBack"></nav-bar>
    <div class="divider"></div>
    <div class="contentBox">
      <div class="introduce">
        <van-field v-model="message" rows="2" autosize type="textarea" maxlength="100" placeholder="自我介绍请填写"
                   show-word-limit/>
        <!-- <van-field /> -->
      </div>
      <div class="agency_fee">
        <van-row class="agency_fee_row">
          <van-col span="19">
            <p class="agency_fee_title">经纪人费用</p>
            <p class="agency_fee_integral">立返2000积分</p>
          </van-col>
          <van-col class="fee_col" span="5">
            <span class="fee_logo">¥</span>
            <span class="fee">2000</span>
          </van-col>
        </van-row>
      </div>
      <!-- <div class="use-vecoin-box">
        <img src="../../../assets/debtor/use-selected.png" v-if="coinSelected != 1" @click="redEnvelopes">
        <img src="../../../assets/debtor/red-selected.png" v-if="coinSelected == 1"
             @click="coinSelected = coinSelected == 1 ? 0 : 1">
        <span v-if="coinSelected != 1">可用红包为{{ parseFloat(nowCoin).toFixed(2) }}元</span>
        <span v-if="coinSelected == 1">红包可抵扣{{ parseFloat(use_coin).toFixed(2) }}元</span>
        <span @click="onClick" class="text">红包使用规则</span>
      </div> -->
      <div class="operation">
        <van-button type="primary" class="operation_btn" @click="payAgencyFees">支付经纪人费用</van-button>
      </div>
    </div>
    <!-- <div class="dialog1">
      <van-dialog
        v-model="showDialog1"
        title="提示"
        message="您还未绑定银行卡"
        confirm-button-text="去绑卡"
        confirm-button-color="#F9591B"
        cancel-button-text="取消"
        cancel-button-color="#999999"
        @confirm="confirmEvent"
        show-cancel-button
      >
      </van-dialog>
    </div> -->

    <div class="loading" v-if="loading">
      <img src="../../../assets/common/loading.gif"/>
    </div>
  </div>

</template>
<script>
import {
  Dialog
} from 'vant';
import navBar from "../components/navBar";

export default {
  name: "introduceMyself",
  data() {
    return {
      message: '',
      client: 0,
      paying: false,
      // showDialog1: false,
      loading: false,
      nowCoin: 0,
      coinSelected: 0,
      use_coin: 0,
      show: false,
      dialogText: '',
      isDeductCoin: 0
    };
  },
  created() {
    this.deductionUA()
    this.getNowCoin()
    this.getDialogText()
  },
  components: {
    navBar,
    [Dialog.Component.name]: Dialog.Component,
  },
  methods: {
    redEnvelopes() {
      if (!this.isDeductCoin) {
        this.coinSelected = 0
        if (this.nowCoin < 100) {
          this.$toast('红包余额不足100，不可使用红包！')
        }
      } else {
          this.coinSelected = 1
      }
    },
    getNowCoin() {
      this.$api.post('/debt/member/coin/deduction/detail', {order_amount: 2000}).then(data => {
        this.nowCoin = data.coin
        this.use_coin = data.max_deduct_coin
        this.isDeductCoin = data.is_deduct_coin
      })
      // this.$api.post('debt/member/agent/query-coin').then(data => {
      //   this.nowCoin = data.nowCoin
      //   this.use_coin = data.use_coin
      // })
    },
    getDialogText() {
      this.$api.get('cms-v2/index/agreement/app/detail?number=GRHB').then((res) => {
        this.dialogText = res.content
        // eslint-disable-next-line no-console
      })

    },
    deductionUA() {
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        this.client = 11;
      } else if (/android/.test(ua)) {
        this.client = 10;
      }
    },
    onClick() {
      // this.show = true
      Dialog.alert({
        message: `${this.dialogText}`,
        theme: 'round-button',
      })
    },
    goBack() {
      this.$router.go(-1);
    },

    // confirmEvent(){
    //   // TODO 绑卡 跳原生参数
    //   const param = {

    //   }
    //   this.params(
    //     JSON.stringify(param),
    //     JSON.stringify(param),
    //     "debtBindingBankCard"
    //   );
    // },

    // 支付代理费=>(确认订单、创建订单、原生支付)
    async payAgencyFees() {

      if (!this.message) {
        this.$toast('请填写自我介绍')
        return
      }

      if (this.paying) return
      this.loading = true
      this.paying = true


      try {
        const param1 = {
          order: {
            type: 'debt',
            client: this.client,
          },
          order_amount: "2000",
          is_use_deduct_credit2: this.coinSelected,
        }
        // console.log(param1.is_use_deduct_credit2)
        const confirm = await this.$api.post('order/member/order/confirm', param1)
        const param2 = {
          order: {
            type: 'debt',
            client: this.client,
            confirm: confirm.order.confirm,
          },
          actual_amount: confirm.order.confirm[0].actual_amount,
          deduct_coin: confirm.order.confirm[0].deduct_coin,
          agent_introduce: this.message,
          order_amount: "2000",
          is_use_deduct_credit2: this.coinSelected,
        }
        await this.$api.post('order/member/order/create', param2).then(data => {
          const param3 = {
            actual_amount: parseFloat(data.actual_amount).toFixed(2),
            deduct_coin: data.deduct_coin,
            deduct_credits: data.deduct_credits,
            order_amount: parseFloat(data.order_amount).toFixed(2),
            ordersn: data.ordersn,
          };
          this.paying = false
          this.loading = false
          // TODO 原生支付 参数确认
          this.params(
              JSON.stringify(param3),
              JSON.stringify(param3),
              "debtAgentPay"
          );
        }).catch(err => {
          if (err.code == 422) {
            this.$toast(err.agent_introduce)
          }
        })

      } catch (err) {
        // if (err.code == 995) {
        //   this.showDialog1 = true
        // }
        if (err.code == 998) {
          this.$toast(err.message)
        }
        if (err.code == 921212) {
          this.$toast("请勿重复提交")
        }

        this.paying = false
        this.loading = false
        // eslint-disable-next-line no-console
        err.message && console.log(err.message)
        this.$toast(err.message)
        this.getNowCoin()
      }

    }
  },
}
</script>
<style lang="less">
.van-dialog__message {
  text-align: inherit !important;
}

.text {
  color: #c8c9cc !important;
  font-size: 12px;
  flex: 1 !important;
  text-align: right;
}

p {
  margin-bottom: 10px;
}

.introduceMyself-warpper {
  padding-top: 88px;
  background-color: #fff;
  color: #333;
  padding-bottom: 20px;
  font-size: 16px;

  // .navbar {
  //   margin: 24px 5px 0 5px;
  // }
  .divider {
    width: 100%;
    height: 12px;
    background: #f5f6f7;
  }

  .introduce {
    height: 100px;
  }

  textarea {
    height: 59px !important;
  }

  .contentBox {
    .agency_fee {
      margin: 15px 12px 24px;
      background: #fff9f1;
      border: 1px solid #d8a170;
      border-radius: 8px;
    }

    .agency_fee_row {
      padding: 18px 20px;
    }

    .agency_fee_title {
      color: #9f5d00;
      font-weight: 600;
    }

    .agency_fee_integral {
      color: #9f5d00;
      margin-top: 6px;
    }

    .fee_col {
      margin-top: 10px;
      line-height: 29px;
    }

    .fee_logo {
      font-size: 14px;
      color: #9f5d00;
    }

    .fee {
      font-size: 24px;
      color: #6a4219;
      font-weight: 600;
    }

    .operation {
      margin: 0 12px;
    }

    .operation_btn {
      width: 100%;
      height: 50px;
      font-size: 17px;
      display: block;
      border-radius: 30px;
      line-height: 50px;
      font-weight: 600;
      background-color: #fc740c;
      color: #fff;
      border: none;
    }

    .use-vecoin-box {
      margin: 15px 12px 24px;
      display: flex;
      align-items: center;

      img {
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }

      span {
        height: 23px;
        font-size: 14px;
        color: #666666;
        line-height: 23px;
        flex: 2;
      }
    }
  }

  .van-field__label {
    width: 4.2em;
    color: #333;
  }

  .van-cell {
    font-size: 16px;
    line-height: 24px;
    background-color: #fff;
    border-bottom: 1px solid #eeeeee;
    color: #333;
  }

  .van-field__word-limit {
    color: #ccc;
    font-size: 16px;
  }

  .dialog1 {
    .van-dialog {
      .van-dialog__header {
        font-size: 18px;
        font-weight: bold;
        padding-top: 20px;
        line-height: 25px;
        height: 25px;
        text-align: center;
      }

      // width: 280px;
      border-radius: 8px;

      .van-dialog__content {
        .van-dialog__message {
          font-size: 16px;
          padding: 15px 0 24px;
          height: 24px;
          line-height: 24px;
        }
      }
    }
  }

  .loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);

    img {
      width: 35%;
      margin-top: 65%;
    }
  }
}
</style>